import { Component } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { BaseSectionComponent } from 'app/shared/base-classes/sections/base-section.component';

import { SectionWrapperComponent } from '../../../../../../shared/components/containers/section-wrapper-container/section-wrapper-container.component';
import { SingleDropdownComponent } from '../../../../../../shared/components/dropdowns/single-dropdown/single-dropdown.component';
import { InputFieldComponent } from '../../../../../../shared/components/input-field/input-field.component';
import { numberCast } from '../../../../../../shared/functions/sectionCasters.function';
import { VehicleRecordModel } from '../../../models/vehicle-record.model';
import { VEHICLE_ELECTRIC_BATTERY_TYPE } from '../../../translations/vehicles-select-items';

@Component({
	selector: 'app-vehicles-motor',
	templateUrl: 'vehicles-motor.component.html',
	imports: [
		ReactiveFormsModule,
		SingleDropdownComponent,
		InputFieldComponent,
		SectionWrapperComponent,
	],
})
export class VehiclesMotorComponent extends BaseSectionComponent<VehicleRecordModel> {
	protected _skipCount: number = 0;

	electricBatteryType = VEHICLE_ELECTRIC_BATTERY_TYPE;

	constructor(private _formBuilder: FormBuilder) {
		super();
		this.detailsForm = this._formBuilder.group({
			averageElectricConsumption: [null],
			electricBatteryCapacity: [null],
			electricBatteryVoltage: [null],
			electricBatteryType: [null],
			electricMotorOutput: [null],
			electricMotorRangeFrom: [null],
			electricMotorRangeTo: [null],
		});
	}

	protected _mapModelToForm(): void {
		const detailsFormData: any = {
			averageElectricConsumption: this.recordData().averageElectricConsumption,
			electricBatteryCapacity: this.recordData().electricBatteryCapacity,
			electricBatteryVoltage: this.recordData().electricBatteryVoltage,
			electricBatteryType: this.recordData().electricBatteryType,
			electricMotorOutput: this.recordData().electricMotorOutput,
			electricMotorRangeFrom: this.recordData().electricMotorRangeFrom,
			electricMotorRangeTo: this.recordData().electricMotorRangeTo,
		};
		this.detailsForm.setValue(detailsFormData, {
			emitEvent: false,
		});
	}

	protected _mapFormToModel(): Partial<VehicleRecordModel> {
		return {
			averageElectricConsumption: numberCast(
				this.detailsForm.value.averageElectricConsumption,
			),
			electricBatteryCapacity: numberCast(
				this.detailsForm.value.electricBatteryCapacity,
			),
			electricBatteryVoltage: numberCast(
				this.detailsForm.value.electricBatteryVoltage,
			),
			electricBatteryType: this.detailsForm.value.electricBatteryType,
			electricMotorOutput: numberCast(
				this.detailsForm.value.electricMotorOutput,
			),
			electricMotorRangeFrom: numberCast(
				this.detailsForm.value.electricMotorRangeFrom,
			),
			electricMotorRangeTo: numberCast(
				this.detailsForm.value.electricMotorRangeTo,
			),
		};
	}
}
